import styled, { keyframes } from "styled-components";

const scanLine = keyframes`
  0%   { transform: translateY(0); opacity: 0; }
  10%  { opacity: 1; }
  90%  { opacity: 1; }
  100% { transform: translateY(var(--frame-size)); opacity: 0; }
`;

const focusPulse = keyframes`
  0%   { transform: scale(1.4); opacity: 0; }
  30%  { transform: scale(1); opacity: 1; }
  100% { transform: scale(1); opacity: 0; }
`;

const fadeIn = keyframes`
  from { opacity: 0; }
  to   { opacity: 1; }
`;

export const QRScannerViewStyled = styled.div`
  --frame-size: min(68vw, 280px);

  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 100;
  overflow: hidden;
  background: ${({ theme }) => theme.COLORS.BLACK_1};
  user-select: none;

  /* video ของ Scanner ต้องเต็มจอ ไม่ใช่ 1:1 ตาม default ของ lib */
  video {
    width: 100% !important;
    height: 100% !important;
    object-fit: cover;
  }

  .qsv_mask {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    pointer-events: none;
    display: flex;
    justify-content: center;
    align-items: center;
    .qsv_frame {
      position: relative;
      width: var(--frame-size);
      height: var(--frame-size);
      border-radius: 24px;
      /* เจาะช่องใสตรงกลาง ที่เหลือมืดลง */
      box-shadow: 0 0 0 9999px rgba(0, 0, 0, 0.6);
      .qsv_corner {
        position: absolute;
        width: 28px;
        height: 28px;
        &.tl {
          top: -2px;
          left: -2px;
          border-top: 3px solid ${({ theme }) => theme.COLORS.WHITE_1};
          border-left: 3px solid ${({ theme }) => theme.COLORS.WHITE_1};
          border-radius: 24px 0 0 0;
        }
        &.tr {
          top: -2px;
          right: -2px;
          border-top: 3px solid ${({ theme }) => theme.COLORS.WHITE_1};
          border-right: 3px solid ${({ theme }) => theme.COLORS.WHITE_1};
          border-radius: 0 24px 0 0;
        }
        &.bl {
          bottom: -2px;
          left: -2px;
          border-bottom: 3px solid ${({ theme }) => theme.COLORS.WHITE_1};
          border-left: 3px solid ${({ theme }) => theme.COLORS.WHITE_1};
          border-radius: 0 0 0 24px;
        }
        &.br {
          bottom: -2px;
          right: -2px;
          border-bottom: 3px solid ${({ theme }) => theme.COLORS.WHITE_1};
          border-right: 3px solid ${({ theme }) => theme.COLORS.WHITE_1};
          border-radius: 0 0 24px 0;
        }
      }
      .qsv_line {
        position: absolute;
        top: 0;
        left: 8px;
        right: 8px;
        height: 2px;
        border-radius: 2px;
        background: linear-gradient(
          90deg,
          transparent,
          ${({ theme }) => theme.COLORS.PURPLE_9},
          transparent
        );
        box-shadow: 0 0 12px ${({ theme }) => theme.COLORS.PURPLE_9};
        animation: ${scanLine} 2.4s ease-in-out infinite;
      }
    }
  }

  .qsv_topbar {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 56px;
    padding: 0 8px;
    display: flex;
    align-items: center;
    .qsv_close {
      width: 44px;
      height: 44px;
      display: flex;
      align-items: center;
      justify-content: center;
      border: none;
      background: transparent;
      cursor: pointer;
    }
    .qsv_title {
      flex: 1;
      text-align: center;
      margin-right: 44px;
      color: ${({ theme }) => theme.COLORS.WHITE_1};
      font-size: ${({ theme }) => theme.FONT.SIZE.S16};
      font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_MEDIUM};
    }
  }

  .qsv_hint {
    position: absolute;
    left: 24px;
    right: 24px;
    top: calc(50% + var(--frame-size) / 2 + 28px);
    text-align: center;
    pointer-events: none;
    color: ${({ theme }) => theme.COLORS.WHITE_1};
    font-size: ${({ theme }) => theme.FONT.SIZE.S16};
    font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_MEDIUM};
    .qsv_sub_hint {
      margin-top: 6px;
      opacity: 0.7;
      font-size: ${({ theme }) => theme.FONT.SIZE.S13};
      font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_REGULAR};
    }
  }

  .qsv_retry {
    position: absolute;
    left: 24px;
    right: 24px;
    top: calc(50% + var(--frame-size) / 2 + 84px);
    padding: 8px;
    border: none;
    background: transparent;
    cursor: pointer;
    animation: ${fadeIn} 0.4s ease;
    color: ${({ theme }) => theme.COLORS.PURPLE_9};
    font-size: ${({ theme }) => theme.FONT.SIZE.S13};
    font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_REGULAR};
    text-decoration: underline;
  }

  .qsv_actions {
    position: absolute;
    left: 0;
    right: 0;
    bottom: calc(32px + env(safe-area-inset-bottom, 0px));
    display: flex;
    justify-content: center;
    gap: 40px;
    .qsv_action {
      width: 76px;
      padding: 0;
      border: none;
      background: transparent;
      cursor: pointer;
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 8px;
      color: ${({ theme }) => theme.COLORS.WHITE_1};
      font-size: ${({ theme }) => theme.FONT.SIZE.S12};
      font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_REGULAR};
      .qsv_action_icon {
        width: 52px;
        height: 52px;
        border-radius: 26px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: rgba(255, 255, 255, 0.16);
        backdrop-filter: blur(6px);
        transition: background 0.2s ease;
      }
      &.active .qsv_action_icon {
        background: ${({ theme }) => theme.COLORS.WHITE_1};
      }
    }
  }

  .qsv_focus_ring {
    position: absolute;
    width: 72px;
    height: 72px;
    margin: -36px 0 0 -36px;
    border: 2px solid ${({ theme }) => theme.COLORS.WHITE_1};
    border-radius: 36px;
    pointer-events: none;
    animation: ${focusPulse} 0.7s ease-out forwards;
  }

  .qsv_decoding {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 2;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(0, 0, 0, 0.7);
    color: ${({ theme }) => theme.COLORS.WHITE_1};
    font-size: ${({ theme }) => theme.FONT.SIZE.S16};
    font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_REGULAR};
  }

  .qsv_loading {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${({ theme }) => theme.COLORS.WHITE_1};
    font-size: ${({ theme }) => theme.FONT.SIZE.S14};
    font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_REGULAR};
  }
`;
